import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CreateNewUserForm from "components/ClinicalManagement/Common/CreateNewUserForm/CreateNewUserForm";

const AddNewDoctor = () => {
  useEffect(() => {
    document.title = "Add New Doctor";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <CreateNewUserForm moduleName="DOCTOR" />
    </main>
  );
};

export default AddNewDoctor;
